import React from 'react';
import { AddOnsContext } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/AddOn/AddOnTab';

export default function useAddOnsContext() {
	return React.useContext(AddOnsContext);
}
